import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsDuperbrowseActive } from '@wix/da-shared-react/pkg/Duperbrowse/redux/selectors';
import { selectors, actions } from '@wix/da-shared-react/pkg/Stream';
import {
  getIsMobile,
  getPagingMode,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import { AppState } from '../../../../../../../types/store';
import { getModuleDataByModuleType } from '../../../../../../selectors/modules';
import { ModuleType } from '../../../../../../../types/modules';

import { Props } from './FeedPagination';

export type StateProps = Pick<
  Props,
  | 'isDuperbrowseActive'
  | 'isFetching'
  | 'hasMore'
  | 'isInfiniteScroll'
  | 'requestUrl'
  | 'currentPage'
  | 'totalPages'
  | 'error'
>;
export type DispatchProps = Pick<Props, 'fetchMore'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { streamId }
) => {
  const streamTotalItems = selectors.getTotal(state, streamId);
  const streamItemsPerFetch = selectors.getItemsPerFetch(state, streamId);
  const {
    currentPage,
    totalPages = Math.ceil(streamTotalItems / streamItemsPerFetch), // TODO: remove the default once T48412 is resolved
  } = getModuleDataByModuleType(state, ModuleType.POSTS_FEED);

  return {
    requestUrl: state.environment.requestUrl,
    isDuperbrowseActive: getIsDuperbrowseActive(state as any),
    isInfiniteScroll: getIsMobile(state) || getPagingMode(state) === 'scroll',
    hasMore: selectors.hasMore(state, streamId),
    isFetching: selectors.isFetching(state, streamId),
    currentPage,
    totalPages,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { streamId }
) => {
  return {
    fetchMore: () => dispatch(actions.fetchNext(streamId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
